// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1vXeV","vLegacy":"SelectSecondary_vLegacy__2VVIV","error":"SelectSecondary_error__1NNeR","disabled":"SelectSecondary_disabled__2hX4C"};